<template>
    <div class="row">
        <div class="col-12">
            <div class="card-header-actions">
              <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                <div class="row align-items-end">
                  <div class="col-12 col-sm-8 card-header-search-box">
                    <div class="input-group">
                        <input class="form-control search-input" type="text" :placeholder="$t('main.search')" v-model="filter.search" @keypress.enter="initList">
                        <div class="input-group-append">
                            <button class="all-btn search-btn" @click="initList">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                <button class="all-btn add-btn m-0" @click="ExciseTaxForCountryEditModal(null)" v-if="hasPermission('SETTINGS_EXCISE_TAX_FOR_COUNTRY_ADD')">{{$t("action.add")}}</button>
              </div>
            </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                  <tr>
                      <th>ID</th>
                      <th>Яратилган сана</th>
                      <th>Яратган фойдаланувчи</th>
                      <th>Ўзгартирилган сана</th>
                      <th>Ўзгартирган фойдаланувчи</th>
                      <th>Мамлакат номи</th>
                      <th>Мамлакат номи (ru)</th>
                      <th>Акциз қиймати (%)</th>
                  </tr>
                  </thead>
                  <tbody v-if="!loading && results && results.data">
                  <tr v-for="result in results.data" :key="result.id">
                      <td>{{result.id}}</td>
                      <td>{{new Date(result.createdDate) | dateFormat('DD.MM.YYYY HH:mm:ss')}}</td>
                      <td>{{result.createdBy.name}}</td>
                      <td>
                          <span v-if="result.updatedDate!=null">{{new Date(result.updatedDate) | dateFormat('DD.MM.YYYY HH:mm:ss')}}</span>
                      </td>
                      <td>{{result.updatedBy!=null?result.updatedBy.name : ''}}</td>
                      <td>{{result.data.name}}</td>
                      <td>{{result.data.nameRu}}</td>
                      <td>{{result.data.rate}}</td>
                  </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <ExciseTaxForCountryEditModal/>
    </div>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import ExciseTaxForCountryEditModal from '@/views/config/auto/ExciseTaxForCountryEditModal';

    export default {
        name: "ExciseTaxForCountry",
        components: {
            'b-pagination': bPagination,
            ExciseTaxForCountryEditModal: ExciseTaxForCountryEditModal
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null,
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('dictionary/list/EXCISE_TAX_FOR_COUNTRY', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            ExciseTaxForCountryEditModal(data) {
                this.$eventBus.$emit('ExciseTaxForCountryEditModal', data);
            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('taxChanged', () => {
                this.initList();
            });
        }
    }
</script>

<style scoped>

</style>